import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzMotores } from '@/mocks/localSeoData';

export default function RecuperacaoMotoresHidraulicosAracruz() {
  return <LocalSeoPage data={aracruzMotores} />;
}